import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import { GlobalContext } from 'store/context/GlobalContext';
import LightBox from 'components/LightBox';
import useGa from 'hooks/useGa';
import { AttrText } from 'components/AttrText';
import useFbq from 'hooks/useFbq';

const Step1 = (props) => {
    const history = useHistory();
    const gaTracking = useGa();
    const fbqTracking = useFbq();
    const { formData, setForm, awardsData, navigation } = props;
    const { next } = navigation;
    const { reset, register } = useForm({ mode: 'onChange', shouldUnregister: true });
    const user = useSelector((state) => state.Auth.user);
    const context = useContext(GlobalContext);
    const { userData } = context;
    const [ inputLightbox, setInputLightbox ] = useState(false);
    const [ pointsLightbox, setPointsLightbox ] = useState(false);

    useEffect(() => {
        let obj = {};
        formData.exchange_list.map((item) => obj[`giveaway${item.awards_id}`] = item.exchange_nu);
        reset(obj);
    }, [formData])
    
    const handleNext = () => {
        gaTracking("giveaway-step1-submit");
        fbqTracking('trackCustom', 'redeem');
        fbqTracking('track', 'SubmitApplication');
        let totalPoints = 0;
        let pointsArr = [];
        if(formData.exchange_list.length < 1){
            setInputLightbox(true);
            return;
        }
        pointsArr = formData.exchange_list.map((item) => 
            awardsData.find(e => e.awards_id === item.awards_id).awards_points*item.exchange_nu
        )
        if(pointsArr.length > 0){
            totalPoints = pointsArr.reduce(function(total, e){
                return total + e;
            });
        }
        if(totalPoints > userData.user_last_points){
            setPointsLightbox(true);
            return;
        }

        next();
    }

    return (
        <div className="inner-container step1">
            <AttrText className="name" text={user.login_name}>{user.login_name}</AttrText>
            <div className="record-box">
                <ul className="record-list">
                    <li className="record-item">
                        <div>已登錄點數</div>
                        <div className="count">{userData.user_points ? userData.user_points : "0"} 點</div>
                    </li>
                    <li className="record-item">
                        <div>已使用</div>
                        <div className="count">{userData.user_used_points ? userData.user_used_points : "0"} 點</div>
                    </li>
                    <li className="record-item">
                        <div>剩餘</div>
                        <div className="count">{userData.user_last_points ? userData.user_last_points : "0"} 點</div>
                    </li>
                </ul>
                <div className="text-secondary font-size-14 mgt-3 pdx-3">每1張瓶貼序號即代表1點，亦有機會隨機出現2點、5點或10點。</div>
            </div>
            <div className="giveaway-box">
                <ul className="giveaway-list">
                    {
                        awardsData.map((item, index) =>
                        <GiveawayItem
                            item={item}
                            formData={formData}
                            setForm={setForm}
                            register={register}
                            key={index}
                        />)
                    }
                </ul>
            </div>
            <div className="content-box">
                <div className="content">
                    <div className="title giveaway-step1-text1"></div>
                    <div className="desc">
                        <div>※ 序號點數需於 2022 年 09 月 12 日前登錄參加活動，逾期點數無效，並視同自行放棄參與權益。</div>
                        <div>※ 敬請妥善保留全部已登錄序號之瓶貼紙本，以供活動單位審核。</div>
                        <div>※ 部分兌換獎品數量有限，換完為止。</div>
                        <div>※ 兌換與抽獎獎品以實物為主，不得挑款。參加者對於本活動抽獎結果應予以尊重，不得異議，如有疑慮請自行斟酌是否參加。</div>
                    </div>
                </div>
            </div>
            <div className="mgt-6">
                <button type="button" className="common-btn yellow" onClick={handleNext}>確認送出</button>
            </div>
            <LightBox
                open={inputLightbox}
                callback={() => setInputLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請先選擇數量</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("giveaway-step1-quantity-error");
                            setInputLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={pointsLightbox}
                callback={() => setPointsLightbox(false)}
                cross
            >
                <div className="light-box-header points-not-enough"></div>
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>多買幾瓶，集滿點數來兌換吧。</div>
                    </div>
                    <div className="button-container mgb-8">
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step1-points-error1");
                                setPointsLightbox(false);
                            }}
                        >
                            返回確認
                        </button>
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step1-points-error2");
                                setTimeout(() => {
                                    history.push("/exchange");
                                }, 0)
                            }}
                        >
                            輸入序號
                        </button>
                    </div>
                </div>
            </LightBox>
        </div>
    )
}

const GiveawayItem = (props) => {
    const { register, formData, setForm, item } = props;
    const [ optionList, setOptionList ] = useState([]);

    useEffect(() => {
        let maxValue = 0;
        let arr = [];
        if(item.awards_last_nu === "∞"){
            maxValue = 30;
        }else{
            if(item.awards_last_nu >= 30){
                maxValue = 30;
            }else{
                maxValue = item.awards_last_nu;
            }
        }
        for(let i = 1; i <= maxValue; i++){
            arr.push(i);
        }
        setOptionList(arr);
    }, [item])

    const handleChange = (item, value) => {
        let result = Array.from(formData.exchange_list);
        let index = result.findIndex(e => e.awards_id === item.awards_id);
        if(index > -1){
            if(value !== ""){
                result[index].exchange_nu = value;
            }else{
                result.splice(index, 1);
            }
        }else{
            result.push({
                awards_id: item.awards_id,
                exchange_nu: value,
            })
        }
        
        setForm({
            target: {
                name: 'exchange_list',
                value: result
            }
        })
    }

    return (
        <li className="giveaway-item">
            <div className="text-left" style={{marginLeft: item.awards_item.includes('可爾必思') ? "-7px" : "2px"}}>
                <label>{item.awards_item} | {item.awards_points}點</label>
                {
                    item.awards_last_nu !== "∞" &&
                    <div className="font-size-12 mgl-2" style={{color: "#F58595"}}>
                        {item.awards_last_nu <= 10 && item.awards_last_nu > 0 && `僅剩${item.awards_last_nu}組，要換要快`}
                        {item.awards_last_nu === 0 && `兌換完畢，感謝支持`}
                    </div>
                }
            </div>
            <select
                style={{marginLeft: item.awards_item.includes('可爾必思') ? "7px" : "-2px"}}
                name={`giveaway${item.awards_id}`}
                defaultValue=""
                {...register(`giveaway${item.awards_id}`)}
                onChange={(e) => handleChange(item, e.target.value)}
                disabled={optionList.length === 0 ? true : false}
            >
                <option value="">請選擇數量</option>
                {
                    optionList.map((item, index) =>
                        <option value={item} key={index}>{item}</option>
                    )
                }
            </select>
        </li>
    )
}

export default Step1;